export enum SharedDocuments {
    Patient = 1,
    Prescriber = 2,
    Drug = 3,
    Insurance = 4,
    Prescription = 5
}

export enum RxOriginEnum {
    NotKnown = 1,
    Written = 2,
    Telephone = 3,
    Electronic = 4,
    Facsimile = 5,
    Pharmacy = 6
}

export enum DrugTypeEnum {
    Prescription = 1,
    Compound = 2,
    Service = 3,
    OTC = 4,
    DurableMedicalEquipment = 5
}

export enum eligibilityEnum{
    troopInsuranceId = 449050,
    CommercialPolicyNum = 987654321,
}

export enum resolveErrorEnum {
    ALL="All",
    Unresolved = "Unresolved",
    Resolved = "Resolved"
}

export enum MultiMedPackagingTypes {
    None =  23,
    HOA =  24,
    BubblePackaging =   138

}

export enum drugBillingUnits {
    EA = 11,
    GM = 15,
    ML = 20
}
export enum VendorCutOffReminderMode {
    Manual = 1,
    Dynamic = 2
}

export enum ReminderType {
    VendorCutOffReminder = 1
}

export enum ReminderRecurrence { 
    OneTime = 1, 
    Daily = 2, 
    Weekly = 3, 
    Monthly = 4, 
    Quarterly = 5, 
    Yearly = 6
}
export enum ReminderCommunicationMode { 
    PopUp = 1
}